import { Layout } from '@sweep-io/sweep-design/dist/icons/Layout';
import { CanvasToolbarButton } from './CanvasToolbarButton';
import { usePanels } from '../../../../panels/usePanels';
import { useHandleCommentsAndAiFirst } from '../left-menu/useHandleCommentsAndAiFirst';
import { templatesPanelType } from '../../../funnel-map-flow/templates/dialog/panelTypes';
import { useCanvasToolbarContext } from './CanvasToolbarCtx';
import { useEffect } from 'react';
import { usePermissions } from '../../../../../permissions/usePermissions';

export const TemplatesAndPluginsToolbarButton = ({ isDisabled }: { isDisabled?: boolean }) => {
  const { maybeOpenPanel } = usePanels();
  const handleCommentsAndAiFirst = useHandleCommentsAndAiFirst();
  const { isPanelOpen, maybeCloseSpecificPanel } = usePanels();
  const isTemplatesAndPluginsPanelOpen = isPanelOpen(templatesPanelType);
  const { activeExclusiveButton, setActiveExclusiveButton } = useCanvasToolbarContext();
  const { hasEveryPermission } = usePermissions();
  const hasFunnelMapPermissions = hasEveryPermission([{ permission: ['edit:funnel-maps', 'edit:funnel-maps:links',] }]);

  useEffect(() => {
    if (activeExclusiveButton !== 'templatesAndPlugins' && isTemplatesAndPluginsPanelOpen) {
      maybeCloseSpecificPanel(templatesPanelType, undefined, {
        // onCloseConfirm: () => setActiveExclusiveButton(null),
      });
    }
  }, [
    activeExclusiveButton,
    isTemplatesAndPluginsPanelOpen,
    maybeCloseSpecificPanel,
    setActiveExclusiveButton,
  ]);

  return (
    <CanvasToolbarButton
      tooltip="Add Templates and Plugins"
      disabledTooltip={
        hasFunnelMapPermissions ? '' : 'To add Templates and Plugins, please contact your admin.'
      }
      onToggle={(pressed: boolean) => {
        if (pressed) {
          handleCommentsAndAiFirst(() => {
            maybeOpenPanel({
              panelType: templatesPanelType,
              onOpen: () => setActiveExclusiveButton('templatesAndPlugins'),
            });
          });
        } else {
          maybeCloseSpecificPanel(templatesPanelType);
        }
      }}
      pressed={isTemplatesAndPluginsPanelOpen}
      disabled={!hasFunnelMapPermissions || isDisabled}
      testId="add-templates-and-plugins-button"
    >
      <Layout />
    </CanvasToolbarButton>
  );
};
